export default class BlockOption

  constructor: (options) ->
    @options = options
    @_selectElements()
    @_initState()
    @$element.data('block-option', @)

  _selectElements: ->
    @$element = $(@options.element)
    @$field = @$element.find('.block-option-field')

  _initState: ->
    @required = @$element.data('required')
    @selected = @$field.prop('checked')

  _inactiveSiblings: ->
    @$element.siblings('.block-option').each (i, blockOption) ->
      $(blockOption).data('block-option').inactive()

  active: ->
    @selected = true
    @$field.prop('checked', @selected).trigger('change')
    @$element.addClass('selected').trigger('change')

    if @options.mode != 'multiple'
      @_inactiveSiblings()

  inactive: ->
    @selected = false
    @$field.prop('checked', @selected).trigger('change')
    @$element.removeClass('selected').trigger('change')


$ ->
  tower.componentPrototypes.BlockOption = BlockOption
